import {type ListItem} from './types';

type ListContentViewProps = {
  items: ListItem['items'];
};

function ListContentView({items}: ListContentViewProps) {
  return (
    <ul className="ms-4 list-outside list-disc">
      {items.map((item, index) => (
        <li key={`static-${index}`}>{item}</li>
      ))}
    </ul>
  );
}

export default ListContentView;
